export const VIEWENVIRONMENT_REQUEST = 'VIEWENVIRONMENT_REQUEST';
export const VIEWENVIRONMENT_SUCCESS = 'VIEWENVIRONMENT_SUCCESS';
export const VIEWENVIRONMENT_DUPLICATE = 'VIEWENVIRONMENT_DUPLICATE';
export const VIEWENVIRONMENT_FAILURE = 'VIEWENVIRONMENT_FAILURE';
export const VIEWENVIRONMENT_LODING = 'VIEWENVIRONMENT_LODING';
